import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ContractComponent } from '@spaq/modules/contract/contract.component';
import { ContractCancelComponent } from '@spaq/modules/contract/pages/contract-cancel.component';
import { ContractViewComponent } from '@spaq/modules/contract/pages/contract-view.component';

import { ParksModule } from '@spaq/modules/parks';
import { PaymentModule } from '@spaq/modules/payment';
import { ServicesModule } from '@spaq/modules/services';
import { SubscriptionModule } from '@spaq/modules/subscription';
import { UserModule } from '@spaq/modules/user';
import { UtilsModule } from '@spaq/modules/utils';
import { VehiclesModule } from '@spaq/modules/vehicles';
import { FormComponent } from '@spaq/shared/components/form';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule, SharedComponentsModule, SharedFormModule } from '@spaq/shared';
import { TranslateModule } from '@ngx-translate/core';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IntlModule } from '@progress/kendo-angular-intl';
import { NgxMdModule } from 'ngx-md';
import {
	ContractBillingDetailsComponent,
	ContractCreateNavComponent,
	ContractHeaderComponent,
	ContractSearchFormComponent,
	ContractSummaryComponent,
	ContractTopMenuComponent,
	SubscriptionDetailsComponent
} from './components';
import {
	ContractConditionsPaymentComponent,
	ContractConditionsServiceComponent,
	ContractCreateComponent,
	ContractCreatePreviewComponent,
	ContractDetailsComponent,
	ContractImportComponent,
	ContractPayComponent,
	ContractSelectParkComponent,
	ContractSelectPaymentComponent,
	ContractSelectServiceComponent,
	ContractSummaryComponent as ContractSummaryComponentB,
	ContractUpdateSubscriptionComponent,
	ContractUpdateVehiclesComponent
} from './pages';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DebounceClickDirective } from '@spaq/modules/contract/click-debounce.directive';

@NgModule({
	imports: [
		SharedCommonModule,
		HttpClientModule,
		ParksModule,
		ServicesModule,
		SharedComponentsModule,
		TranslateModule,
		DropDownsModule,
		SubscriptionModule,
		VehiclesModule,
		PaymentModule,
		UserModule,
		DateInputsModule,
		IntlModule,
		SharedCommonModule,
		UtilsModule,
		NgxMdModule,
		FormModule,
		SharedFormModule,
		LayoutModule
	],
	declarations: [
		ContractComponent,
		ContractDetailsComponent,
		ContractImportComponent,
		ContractSearchFormComponent,
		ContractViewComponent,
		ContractConditionsServiceComponent,
		ContractConditionsPaymentComponent,
		ContractCreateComponent,
		ContractSummaryComponent,
		ContractSummaryComponentB,
		SubscriptionDetailsComponent,
		ContractCancelComponent,
		ContractPayComponent,
		ContractHeaderComponent,
		ContractTopMenuComponent,
		ContractBillingDetailsComponent,
		ContractCreateNavComponent,
		ContractSelectParkComponent,
		ContractSelectServiceComponent,
		ContractSelectPaymentComponent,
		ContractUpdateSubscriptionComponent,
		ContractUpdateVehiclesComponent,
		ContractCreatePreviewComponent,
		DebounceClickDirective
	],
	exports: [
		ContractComponent,
		ContractDetailsComponent,
		ContractImportComponent,
		ContractSearchFormComponent,
		ContractViewComponent,
		ContractConditionsServiceComponent,
		ContractConditionsPaymentComponent,
		ContractCreateComponent,
		ContractSummaryComponent,
		ContractSummaryComponentB,
		SubscriptionDetailsComponent,
		ContractCancelComponent,
		ContractPayComponent,
		ContractHeaderComponent,
		ContractTopMenuComponent
	]
})
export class ContractModule {
	static forRoot(): ModuleWithProviders<ContractModule> {
		return {
			ngModule: ContractModule,
			providers: [FormComponent]
		};
	}
}
